export const IMG_TYPES = [
  'challenge',
  'collection',
  'cefr',
  'native',
  'compare',
  'page',
  'english-iq-result',
] as const;

export type ImgTypeType = (typeof IMG_TYPES)[number];
